/**
 * The client screens' iOS scroll-on-focus harden (shared-client-screens D2): while a client
 * screen is mounted the document never scrolls behind it; the screen scrolls inside itself.
 * Browser-only, so the app's screens and the website's run the same lock.
 */
import { useEffect } from 'react';

export function useClientLock(): void {
  useEffect(() => {
    document.documentElement.classList.add('client-lock');
    document.body.classList.add('client-lock');
    return () => {
      document.documentElement.classList.remove('client-lock');
      document.body.classList.remove('client-lock');
    };
  }, []);
}
